import React from 'react'
import PropTypes from 'prop-types'
import Wizard from '../Wizard'

import ApplicationFormPage from '../pages/ApplicationFormPage'
import ApplicationSignPage from '../pages/ApplicationSignPage'
import ApplicationRejectedPage from '../pages/ApplicationRejectedPage'
import ApplicationInspectionPage from '../pages/ApplicationInspectionPage'
import ApplicationDonePage from '../pages/ApplicationDonePage'
import ApplicationSupplementingRequiredPage from '../pages/ApplicationSupplementingRequiredPage'

import PaymentMethodsPage from '../pages/PaymentMethodsPage'
import PaymentRejectedPage from '../pages/PaymentRejectedPage'
import PaymentInspectionPage from '../pages/PaymentInspectionPage'
import PaymentIdentificationPage from '../pages/PaymentIdenficationPage'
import PaymentDonePage from '../pages/PaymentDonePage'
import PaymentAdjustAmountPage from '../pages/PaymentAdjustAmountPage/PaymentAdjustAmountPage'

import GovernmentIdPage from '../pages/GovernmentIdPage'
import ErrorPage from '../pages/ErrorPage'

import { CustomerTypeModel, PageModel } from '../models/private-models'

import { getText } from '../../../internal/TextLabels'
import {
  sendIdOrSigningEvent,
  sendFinishedEvent,
} from '../../../util/ga-helpers'
import { DelayedPaymentDonePage } from '../pages/DelayedPaymentDonePage/DelayedPaymentDonePage'
import PushOutDonePage from '../pages/PushOutDonePage'

const page = (
  currentPage,
  payApply,
  onNext,
  onPrevious,
  onCancel,
  history,
  logout,
) => {
  switch (currentPage) {
    case PageModel.GOVERNMENT_ID:
      return <GovernmentIdPage onNext={onNext} data={payApply} />
    case PageModel.PAYMENT_METHOD:
      return (
        <PaymentMethodsPage
          onNext={onNext}
          onPrevious={onPrevious}
          data={payApply}
          paymentMethodsExist={payApply.paymentMethods?.length > 0}
        />
      )
    case PageModel.APPLICATION_SIGN:
    case PageModel.PAYMENT_SIGN:
      sendIdOrSigningEvent(payApply, 'Message: Låt kunden signera')
      return <ApplicationSignPage onNext={onNext} data={payApply} />
    case PageModel.PAYMENT_IDENTIFICATION:
      return <PaymentIdentificationPage onNext={onNext} data={payApply} />
    case PageModel.PAYMENT_REJECTED:
      sendIdOrSigningEvent(payApply, 'Message: Köpet nekades')
      return (
        <PaymentRejectedPage
          onNext={onNext}
          onCancel={onCancel}
          rejectedReason={payApply.payment.paymentResult?.rejectedReason}
          data={payApply}
        />
      )
    case PageModel.APPLICATION_INSPECTION:
      sendIdOrSigningEvent(
        payApply,
        'Message: Ansökan behöver hanteras manuellt.',
      )
      return (
        <ApplicationInspectionPage
          onCancel={onCancel}
          onNext={onNext}
          data={payApply}
        />
      )
    case PageModel.APPLICATION_SUPPLEMENTING_REQUIRED:
      sendIdOrSigningEvent(
        payApply,
        'Message: Ytterligare information behövs i ansökan.',
      )
      if (payApply.wizard.wizard === CustomerTypeModel.NATURAL) {
        return (
          <ApplicationInspectionPage
            onCancel={onCancel}
            onNext={onNext}
            data={payApply}
          />
        )
      }
      return (
        <ApplicationSupplementingRequiredPage
          onCancel={onCancel}
          onNext={onNext}
          data={payApply}
        />
      )
    case PageModel.APPLICATION_REJECTED:
      sendIdOrSigningEvent(payApply, 'Message: Ansökan nekades')
      return (
        <ApplicationRejectedPage
          onNext={onNext}
          onCancel={onCancel}
          data={payApply}
        />
      )
    case PageModel.APPLICATION_DONE:
      sendFinishedEvent(payApply, 'Message: Ansökan genomförd')
      return (
        <ApplicationDonePage
          onNext={onNext}
          data={payApply}
          history={history}
        />
      )
    case PageModel.PAYMENT_DONE:
      sendFinishedEvent(payApply, 'Message: Betalningen genomförd')
      return <PaymentDonePage onNext={onNext} data={payApply} />
    case PageModel.SIGNING_REQUEST_SENT:
      sendFinishedEvent(
        payApply,
        'Message: Signeringslänk är skickad till kund',
      )
      return <DelayedPaymentDonePage onNext={onNext} data={payApply} />
    case PageModel.ERROR:
      sendIdOrSigningEvent(payApply, 'Message: Felsidan visades.')
      return <ErrorPage onCancel={onCancel} data={payApply} onNext={onNext} />
    case PageModel.PAYMENT_INSPECTION:
      sendIdOrSigningEvent(payApply, 'Message: Betalningen inspekteras.')
      return (
        <PaymentInspectionPage
          onCancel={onCancel}
          onNext={onNext}
          data={payApply}
        />
      )
    case PageModel.PAYMENT_METHOD_FORM_SPEC:
      return (
        <ApplicationFormPage
          onNext={onNext}
          data={payApply}
          onPrevious={onPrevious}
        />
      )
    case PageModel.PAYMENT_ADJUST_PURCHASE_AMOUNT:
      sendIdOrSigningEvent(payApply, 'Message: Beloppet justerades.')
      return (
        <PaymentAdjustAmountPage
          onNext={onNext}
          data={payApply}
          onPrevious={onPrevious}
        />
      )
    case PageModel.PAYMENT_PUSHED_OUT_TO_CUSTOMER:
    case PageModel.APPLICATION_PUSHED_OUT_TO_CUSTOMER:
      sendIdOrSigningEvent(payApply, 'Message: Formulär skickat till kund.')
      return (
        <PushOutDonePage
          data={payApply}
          logout={logout}
          hasCoApplicant={!!payApply.redirectionResult.coApplicant?.url}
        />
      )
    default:
      return null
  }
}

const PayApplyUI = ({
  currentStep,
  steps,
  currentPage,
  data,
  onNext,
  onPrevious,
  onCancel,
  history,
  logout,
}) => (
  <section id="wizard">
    <Wizard
      title={getText('payApply.title')}
      activeStep={currentStep}
      currentPage={currentPage}
      steps={steps}
      data={data}
      onPrevious={onPrevious}
      onCancel={onCancel}
    >
      {page(currentPage, data, onNext, onPrevious, onCancel, history, logout)}
    </Wizard>
  </section>
)

PayApplyUI.propTypes = {
  steps: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  currentPage: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
}

export default PayApplyUI
